var map = {
	"./ tsc-jersey.png": 62084,
	"./aek-athens-jersey.png": 20761,
	"./afc-bournemouth-jersey.png": 49287,
	"./ajaccio-jersey.png": 82826,
	"./ajax-jersey.png": 91668,
	"./alaves-jersey.png": 69000,
	"./albania-jersey.png": 8862,
	"./algeria-jersey.png": 43649,
	"./almeria-jersey.png": 54095,
	"./amazulu-jersey.png": 42437,
	"./angers-sco-jersey.png": 98716,
	"./angola-jersey.png": 60392,
	"./antwerp-jersey.png": 94333,
	"./argentina-jersey.png": 42007,
	"./aris-limassol-jersey.png": 69612,
	"./arsenal-jersey.png": 9040,
	"./astana-jersey.png": 72880,
	"./aston-villa-jersey.png": 98578,
	"./atalanta-jersey.png": 84578,
	"./athletic-club-jersey.png": 12661,
	"./atletic-club-d'escaldes-jersey.png": 96719,
	"./atletico-madrid-jersey.png": 14385,
	"./australia-jersey.png": 46080,
	"./austria-jersey.png": 60325,
	"./auxerre-jersey.png": 68742,
	"./ballkani-jersey.png": 12238,
	"./barcelona-jersey.png": 57947,
	"./baroka-jersey.png": 20212,
	"./bate-jersey.png": 3268,
	"./bayer-leverkusen-jersey.png": 6782,
	"./bayern-munchen-jersey.png": 22388,
	"./belgium-jersey.png": 83979,
	"./benfica-jersey.png": 35330,
	"./bodo-glimt-jersey.png": 96866,
	"./bologna-jersey.png": 96844,
	"./borussia-dortmund-jersey.png": 1552,
	"./braga-jersey.png": 73377,
	"./brazil-jersey.png": 87692,
	"./breidablik-jersey.png": 4253,
	"./brentford-jersey.png": 2754,
	"./brest-jersey.png": 17542,
	"./brighton-&-hove-albion-jersey.png": 15187,
	"./buducnost-jersey.png": 78745,
	"./burkina-faso-jersey.png": 28562,
	"./burnley-jersey.png": 67655,
	"./cabo-verde-jersey.png": 69514,
	"./cadiz-jersey.png": 26837,
	"./cagliari-jersey.png": 1766,
	"./cameroon-jersey.png": 63614,
	"./canada-jersey.png": 79380,
	"./cape-town-city-jersey.png": 21403,
	"./cape-town-spurs-jersey.png": 31852,
	"./celta-de-vigo-jersey.png": 40641,
	"./celtic-jersey.png": 18606,
	"./chelsea-jersey.png": 89023,
	"./china-pr-jersey.png": 60750,
	"./chippa-united-jersey.png": 97509,
	"./clermont-jersey.png": 59944,
	"./club-brugge-jersey.png": 91613,
	"./colombia-jersey.png": 17804,
	"./como-jersey.png": 11392,
	"./congo-dr-jersey.png": 9785,
	"./costa-rica-jersey.png": 52316,
	"./cote-d'ivoire-jersey.png": 20805,
	"./cremonese-jersey.png": 45759,
	"./croatia-jersey.png": 27679,
	"./crystal-palace-jersey.png": 86719,
	"./czech-republic-jersey.png": 55160,
	"./denmark-jersey.png": 19316,
	"./deportivo-alaves-jersey.png": 60947,
	"./dinamo-tbilisi-jersey.png": 16351,
	"./dinamo-zagreb-jersey.png": 67244,
	"./durban-city-jersey.png": 17458,
	"./ecuador-jersey.png": 31969,
	"./egypt-jersey.png": 99845,
	"./eintracht-frankfurt-jersey.png": 80614,
	"./elche-jersey.png": 22611,
	"./empoli-jersey.png": 54981,
	"./england-jersey.png": 70047,
	"./equatorial-guinea-jersey.png": 33703,
	"./espanyol-jersey.png": 87715,
	"./everton-jersey.png": 38339,
	"./ferencvaros-jersey.png": 86004,
	"./feyenoord-jersey.png": 14721,
	"./fiorentina-jersey.png": 13123,
	"./flora-jersey.png": 65732,
	"./france-jersey.png": 59265,
	"./frosinone-jersey.png": 27701,
	"./fulham-jersey.png": 57677,
	"./galatasaray-jersey.png": 55178,
	"./gambia-jersey.png": 73115,
	"./genoa-jersey.png": 48532,
	"./georgia-jersey.png": 99438,
	"./germany-jersey.png": 22687,
	"./getafe-jersey.png": 68012,
	"./ghana-jersey.png": 81525,
	"./girona-jersey.png": 35864,
	"./golden-arrows-jersey.png": 72440,
	"./granada-jersey.png": 99448,
	"./guinea-bissau-jersey.png": 31463,
	"./guinea-jersey.png": 58475,
	"./hacken-jersey.png": 41456,
	"./haiti-jersey.png": 19739,
	"./hamrun-spartans-jersey.png": 75552,
	"./hellas-verona-jersey.png": 91139,
	"./hjk-jersey.png": 31261,
	"./hungary-jersey.png": 81372,
	"./internazionale-jersey.png": 93631,
	"./ipswich-town-jersey.png": 10950,
	"./iran-jersey.png": 91730,
	"./italy-jersey.png": 7353,
	"./jamaica-jersey.png": 8292,
	"./japan-jersey.png": 24046,
	"./juventus-jersey.png": 66796,
	"./kairat-jersey.png": 58936,
	"./kaizer-chiefs-jersey.png": 61895,
	"./ki-jersey.png": 67570,
	"./kobenhavn-jersey.png": 30934,
	"./korea-republic-jersey.png": 24311,
	"./larne-jersey.png": 78524,
	"./las-palmas-jersey.png": 24277,
	"./lazio-jersey.png": 62525,
	"./le-havre-jersey.png": 782,
	"./lecce-jersey.png": 84910,
	"./leeds-united-jersey.png": 77531,
	"./leganes-jersey.png": 12185,
	"./leicester-city-jersey.png": 32700,
	"./lens-jersey.png": 37934,
	"./levante-jersey.png": 62141,
	"./lille-jersey.png": 63616,
	"./lincoln-red-imps-jersey.png": 46589,
	"./liverpool-jersey.png": 27256,
	"./lorient-jersey.png": 92707,
	"./ludogorets-jersey.png": 82450,
	"./luton-town-jersey.png": 21809,
	"./maccabi-haifa-jersey.png": 17754,
	"./magesi-jersey.png": 62628,
	"./mali-jersey.png": 74711,
	"./mallorca-jersey.png": 45453,
	"./mamelodi-sundowns-jersey.png": 27928,
	"./manchester-city-jersey.png": 93860,
	"./manchester-united-jersey.png": 86568,
	"./maritzburg-united-jersey.png": 64211,
	"./marumo-gallants-jersey.png": 34842,
	"./mauritania-jersey.png": 97455,
	"./metz-jersey.png": 64438,
	"./mexico-jersey.png": 22985,
	"./milan-jersey.png": 62675,
	"./molde-jersey.png": 15237,
	"./monaco-jersey.png": 78753,
	"./montpellier-jersey.png": 44077,
	"./monza-jersey.png": 52217,
	"./morocco-jersey.png": 9900,
	"./mozambique-jersey.png": 37924,
	"./namibia-jersey.png": 94623,
	"./nantes-jersey.png": 65609,
	"./napoli-jersey.png": 21913,
	"./netherlands-jersey.png": 48354,
	"./new-zealand-jersey.png": 48060,
	"./newcastle-united-jersey.png": 26632,
	"./nice-jersey.png": 18335,
	"./nigeria-jersey.png": 59221,
	"./norway-jersey.png": 91064,
	"./norwich-jersey.png": 75498,
	"./nottingham-forest-jersey.png": 24323,
	"./olimpija-jersey.png": 94053,
	"./olympiakos-piraeus-jersey.png": 68286,
	"./olympique-lyonnais-jersey.png": 40607,
	"./olympique-marseille-jersey.png": 25274,
	"./orbit-college-jersey.png": 61574,
	"./orlando-pirates-jersey.png": 91020,
	"./osasuna-jersey.png": 23894,
	"./pafos-jersey.png": 59871,
	"./panama-jersey.png": 28894,
	"./panathinaikos-jersey.png": 85332,
	"./parma-jersey.png": 95807,
	"./partizani-tirana-jersey.png": 18398,
	"./philippines-jersey.png": 72849,
	"./pisa-jersey.png": 18585,
	"./poland-jersey.png": 47342,
	"./polokwane-city-jersey.png": 43518,
	"./porto-jersey.png": 3766,
	"./portugal-jersey.png": 39956,
	"./psg-jersey.png": 50076,
	"./qarabag-jersey.png": 56885,
	"./qatar-jersey.png": 46307,
	"./rakow-czestochowa-jersey.png": 42879,
	"./rangers-jersey.png": 85716,
	"./rayo-vallecano-jersey.png": 93797,
	"./rb-leipzing-jersey.png": 93269,
	"./real-betis-jersey.png": 6432,
	"./real-madrid-jersey.png": 51012,
	"./real-oviedo-jersey.png": 81223,
	"./real-sociedad-jersey.png": 3491,
	"./real-valladolid-jersey.png": 96463,
	"./reims-jersey.png": 33486,
	"./rennes-jersey.png": 21915,
	"./republic-of-ireland-jersey.png": 41906,
	"./richards-bay-jersey.png": 39031,
	"./roma-jersey.png": 72679,
	"./romania-jersey.png": 12925,
	"./royal-am-jersey.png": 71606,
	"./salernitana-jersey.png": 52534,
	"./salzburg-jersey.png": 40946,
	"./sampdoria-jersey.png": 70242,
	"./sassuolo-jersey.png": 66797,
	"./saudi-arabia-jersey.png": 2675,
	"./scotland-jersey.png": 53086,
	"./sekhukhune-jersey.png": 56563,
	"./sekhukhune-united-jersey.png": 79709,
	"./senegal-jersey.png": 64925,
	"./serbia-jersey.png": 42616,
	"./servette-jersey.png": 2636,
	"./sevilla-jersey.png": 33142,
	"./shakhtar-donetsk-jersey.png": 64277,
	"./shamrock-rovers-jersey.png": 65396,
	"./sheffield-united-jersey.png": 13462,
	"./sheriff-jersey.png": 84049,
	"./siwelele-jersey.png": 48642,
	"./slavia-praha-jersey.png": 39643,
	"./slovakia-jersey.png": 94870,
	"./slovan-bratislava-jersey.png": 61261,
	"./slovenia-jersey.png": 44353,
	"./south-africa-jersey.png": 89604,
	"./southampton-jersey.png": 30656,
	"./spain-jersey.png": 89439,
	"./sparta-praha-jersey.png": 22902,
	"./spezia-jersey.png": 75304,
	"./sporting-braga-jersey.png": 43590,
	"./sporting-cp-jersey.png": 78900,
	"./stellenbosch-jersey.png": 44702,
	"./strasbourg-jersey.png": 52718,
	"./struga-jersey.png": 33032,
	"./sturm-graz-jersey.png": 71122,
	"./stuttgart-jersey.png": 922,
	"./sunderland-jersey.png": 71258,
	"./supersport-united-jersey.png": 37139,
	"./swallows-jersey.png": 79950,
	"./sweden-jersey.png": 57086,
	"./swift-hesperange-jersey.png": 65068,
	"./switzerland-jersey.png": 70655,
	"./tanzania-jersey.png": 49648,
	"./the-new-saints-jersey.png": 99875,
	"./torino-jersey.png": 77157,
	"./tottenham-hotspur-jersey.png": 38748,
	"./toulouse-jersey.png": 62630,
	"./tre-penne-jersey.png": 83240,
	"./troyes-jersey.png": 69564,
	"./ts-galaxy-jersey.png": 56922,
	"./tsc-jersey.png": 19836,
	"./tunisia-jersey.png": 97387,
	"./turkey-jersey.png": 58428,
	"./udinese-jersey.png": 12355,
	"./ukraine-jersey.png": 51635,
	"./union-berlin-jersey.png": 48328,
	"./union-saint-gilloise-jersey.png": 55348,
	"./united-states-jersey.png": 5682,
	"./urartu-jersey.png": 19601,
	"./uruguay-jersey.png": 52914,
	"./valencia-jersey.png": 8721,
	"./valladolid-jersey.png": 10756,
	"./valmiera-jersey.png": 46491,
	"./venezia-jersey.png": 29186,
	"./vietnam-jersey.png": 87446,
	"./viitorul-jersey.png": 51914,
	"./viktoria-plzen-jersey.png": 46303,
	"./villarreal-jersey.png": 75232,
	"./wales-jersey.png": 5342,
	"./watford-jersey.png": 49911,
	"./west-ham-united-jersey.png": 77514,
	"./wolverhampton-wanderers-jersey.png": 378,
	"./young-boys-jersey.png": 43242,
	"./zalgiris-jersey.png": 36825,
	"./zambia-jersey.png": 60246,
	"./zrinjski-jersey.png": 26010
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25571;